import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled, { css, createGlobalStyle } from 'styled-components'
import { ReactComponent as Logo } from '../../assets/images/logo.svg'
import CommonIconButton from './CommonIconButton'

const CommonHeader = ({
  className,
  isMain,
  width,
  height,
  title,
  openMenu,
  ...props
}) => {
  const history = useHistory()

  return (
    <>
      <MenuIconStyle />
      <HeaderWrapper
        className={className}
        width={width}
        height={height}
        style={{ ...props.style }}>
        {isMain ? (
          <>
            <Logo className="left-icon" onClick={() => history.push('/')} />
            <span className="right-icon">
              <CommonIconButton
                iconButtonType="plus"
                style={{ marginRight: '10px' }}
                onClick={() => history.push('/post/new')}
              />
              <CommonIconButton iconButtonType="menu" onClick={openMenu} />
            </span>
          </>
        ) : (
          <>
            <CommonIconButton
              className="left-icon"
              iconButtonType="back"
              onClick={() => history.goBack()}
            />
            <h3 className="center-icon">{title}</h3>
            <CommonIconButton
              className="right-icon"
              iconButtonType="menu"
              onClick={openMenu}
            />
          </>
        )}
      </HeaderWrapper>
    </>
  )
}

CommonHeader.propTypes = {
  className: PropTypes.string,
  isMain: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  title: PropTypes.string,
}

const MenuIconStyle = createGlobalStyle`
  .left-icon {
    align-items: flex-start;
    margin-right: auto;
    cursor: pointer;
    width: 30px;
    height: 30px;
  }
  .center-icon {
    text-align: center;
    align-items: center;
    font-weight: normal;
    margin: 0 auto;
    font-size: 18px;
  }
  .right-icon {
    align-items: flex-end;
    margin-left: auto;
    cursor: pointer;
  }
`

const HeaderWrapper = styled.header`
  display: flex;
  gap: 0px 10px;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
    `}
`

export default CommonHeader
